import { useTranslation } from "react-i18next";
import { BsCoin } from "react-icons/bs";
import { GiAlarmClock, GiCoins, GiCrownCoin } from "react-icons/gi";
import {
  MdCurrencyFranc,
  MdDashboard,
  MdMoving,
  MdPercent,
  MdSupervisedUserCircle,
  MdVideoLibrary,
  MdEmail,
} from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SiBloglovin } from "react-icons/si";
import { UseAuth } from "src/auth/AuthContext";
import { getProfileDefaultImage, validateRouteRole } from "src/helpers/mixins";
import ImgKing from "src/assets/images/king.png";
import { useEffect } from "react";
import React from "react";
import {
  FaCommentDots,
  FaIdCard,
  FaMobileAlt,
  FaUserTie,
  FaUsers,
} from "react-icons/fa";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { TbCurrencyPeso } from "react-icons/tb";
import { BiLogOut, BiVideo } from "react-icons/bi";

const SideBarAdmin: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = UseAuth();
  const location = useLocation();
  let { pathname } = location;
  const role = user?.role || "user";
  const enableRoutes = validateRouteRole(role);

  useEffect(() => {
    if (pathname.includes("detalle/") && user?.role === "cajerobolivares") {
      const find = pathname.indexOf("/detalle/");
      pathname = pathname.substring(0, find + 8);
    }
    if (!enableRoutes.includes(pathname) && user?.role === "cajerobolivares") {
      navigate("/admin");
    }
  }, [pathname]);

  // Función para reproducir el sonido close.mp3
  const playCloseSound = () => {
    const audio = new Audio("/sound/close.mp3");
    audio.volume = 0.3; // Ajustar volumen al 30%
    audio.play().catch(error => {
      console.log("Error reproduciendo sonido:", error);
    });
  };

  const menuItems = [
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin"),
      to: "/admin",
      icon: <MdDashboard size={14} />,
      label: "Dashboard"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/app/movil"),
      to: "/admin/app/movil",
      icon: <FaMobileAlt size={14} />,
      label: "APP Señales"
    }, 
    {
      condition:  enableRoutes.includes("/admin/app/provider"),
      to: "/admin/app/movil",
      icon: <FaMobileAlt size={14} />,
      label: "APP Señales"
    },          
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/cajeros"),
      to: "/admin/cashier",
      icon: <FaUserTie size={14} />,
      label: "Cajeros"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/coins"),
      to: "/admin/coins",
      icon: <BsCoin size={14} />,
      label: "Coins casa"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/depositos"),
      to: "/admin/depositos",
      icon: <FaMoneyBillTransfer size={14} />,
      label: t("sidebar.deposits")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/solicitud-coins"),
      to: "/admin/solicitud-coins",
      icon: <GiCrownCoin size={14} />,
      label: "Transferir Coins"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/cuentas-pago-coins"),
      to: "/admin/cuenta-pago-coins",
      icon: <GiCoins size={14} />,
      label: "Cuenta pago coins"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/usuario/lista"),
      to: "/admin/usuario/lista",
      icon: <FaUsers size={14} />,
      label: t("sidebar.users")
    },
  
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/fee-de-ganancia"),
      to: "/admin/fee-de-ganancia",
      icon: <MdPercent size={14} />,
      label: "Fee de ganancia"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/fiat"),
      to: "/admin/fiat",
      icon: <MdCurrencyFranc size={14} />,
      label: t("sidebar.fiat")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/procesadores"),
      to: "/admin/procesadores",
      icon: <TbCurrencyPeso size={14} />,
      label: t("sidebar.process")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/verificaciones"),
      to: "/admin/verificaciones",
      icon: <FaIdCard size={14} />,
      label: "KYC"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/transferencias/opiniones"),
      to: "/admin/transferencias/opiniones",
      icon: <FaCommentDots size={14} />,
      label: "Opiniones"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/depositos/tiempo"),
      to: "/admin/depositos/tiempo",
      icon: <GiAlarmClock size={14} />,
      label: t("sidebar.deposittime")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/roles"),
      to: "/admin/roles",
      icon: <MdSupervisedUserCircle size={14} />,
      label: t("sidebar.roles")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/blog"),
      to: "/admin/blog",
      icon: <SiBloglovin size={14} />,
      label: t("sidebar.blog")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/videos"),
      to: "/admin/videos",
      icon: <BiVideo size={14} />,
      label: t("Video")
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/videos"),
      to: "/admin/videos/promocional",
      icon: <MdVideoLibrary size={14} />,
      label: t("Video") + " promocional"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/emails"),
      to: "/admin/emails",
      icon: <MdEmail size={14} />,
      label: "Emails"
    },
    {
      condition: enableRoutes.includes("*") || enableRoutes.includes("/admin/weltrade"),
      to: "/admin/weltrade",
      icon: <MdMoving size={14} />,
      label: "Weltrade"
    }
  ];

  return (
    <div className="sidebar fixed h-screen bg-gradient-to-b from-white to-gray-50 border-r border-gray-200 shadow-lg mr-4" style={{ width: "240px" }}>
      {/* User Profile Section */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-3">
          <div className="relative">
            <img
              src={ImgKing}
              alt="crown"
              className="w-5 z-10 absolute -right-1 -top-3"
            />
            <div
              className="w-10 h-10 bg-cover bg-center rounded-full border-2 border-green-admin cursor-pointer hover:border-green-admin-dark transition-colors"
              onClick={() => navigate(`/usuario/${user?.id}`)}
              style={{
                backgroundImage: `url(${
                  (user?.photoUrl?.length || 0) > 0
                    ? process.env.REACT_APP_PROFILEPICTURE + (user?.photoUrl || "")
                    : getProfileDefaultImage()
                })`,
              }}
            />
          </div>
          <div className="flex-1 min-w-0">
            <div
              onClick={() => navigate(`/usuario/${user?.id}`)}
              className="font-semibold text-gray-800 cursor-pointer hover:text-green-admin transition-colors truncate text-sm"
            >
              {user?.fullname}
            </div>
            <div className="text-xs text-gray-500 capitalize">
              {user?.role}
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <div className="flex-1 overflow-y-auto py-3 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 relative" style={{ maxHeight: 'calc(100vh - 140px)' }}>
        <nav className="space-y-1 px-3">
          {menuItems.map((item, index) => (
            item.condition && (
              <Link
                key={index}
                to={item.to}
                onClick={playCloseSound}
                className={`group flex items-center px-3 py-2 text-xs font-medium rounded-lg transition-all duration-200 ${
                  pathname === item.to
                    ? "bg-green-admin text-white shadow-md"
                    : "text-gray-700 hover:bg-green-admin/10 hover:text-green-admin"
                }`}
              >
                <span className={`mr-2 transition-colors ${
                  pathname === item.to ? "text-white" : "text-gray-500 group-hover:text-green-admin"
                }`}>
                  {item.icon}
                </span>
                <span className="truncate">{item.label}</span>
              </Link>
            )
          ))}
        </nav>
        
        {/* Scroll indicator */}
        <div className="absolute right-1 top-0 bottom-0 w-1 bg-gray-200 rounded-full opacity-0 hover:opacity-100 transition-opacity duration-200 pointer-events-none"></div>
      </div>

      {/* Logout Section */}
      <div className="p-3 border-t border-gray-200">
        <Link
          to="/salir"
          onClick={playCloseSound}
          className="flex items-center px-3 py-2 text-xs font-medium text-red-600 hover:bg-red-50 hover:text-red-700 rounded-lg transition-all duration-200"
        >
          <BiLogOut size={14} className="mr-2" />
          {t("exit")}
        </Link>
      </div>
    </div>
  );
};

export default SideBarAdmin;
